import axios from "axios";

export const segmentationAPI = axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}/segmentation/`,
});
